import { render, staticRenderFns } from "./Assignation.vue?vue&type=template&id=7a509aa6&scoped=true&"
import script from "./Assignation.vue?vue&type=script&lang=js&"
export * from "./Assignation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a509aa6",
  null
  
)

export default component.exports